module.exports = __webpack_public_path__ + "static/media/nonagone-white-1.d254de55.svg";